import { isRecord } from '@/helpers/isRecord'
import { FetchResourceError } from '@/japi/types/FetchResourceError'

export const isErrorDocument = (japiDocument: unknown): japiDocument is FetchResourceError => isRecord(japiDocument) && 'errors' in japiDocument && ! ('data' in japiDocument)
